import { render, staticRenderFns } from "./ZoneEditorView.vue?vue&type=template&id=5a222408&"
import script from "./ZoneEditorView.vue?vue&type=script&lang=js&"
export * from "./ZoneEditorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a222408')) {
      api.createRecord('5a222408', component.options)
    } else {
      api.reload('5a222408', component.options)
    }
    module.hot.accept("./ZoneEditorView.vue?vue&type=template&id=5a222408&", function () {
      api.rerender('5a222408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/domains/ZoneEditorView.vue"
export default component.exports